import { createReducer, on } from "@ngrx/store";
import { billActions } from "../bill.actions";

export interface ExcelState {
    blob: Blob|null
}

export const initialState: ExcelState = {
    blob: null
};

export const billsGetExcelReducer = createReducer(
    initialState,
    on(billActions.getExcelSuccess, (state, {payload}) => ({
        ...state,
        blob: payload
    })),
    on(billActions.clearExcel, (state) => initialState)
)